// @flow

import React from 'react';
import styled from 'styled-components';
import {
  NewsPreviewGrid,
  NewsPreviewHighlight,
  NewsOverviewContainer,
  LoadMoreButton,
} from '@leasen_nl/listo/src/components/news';
import Rows from '@leasen_nl/listo/src/components/rows';
import type { ACFPage } from '@leasen_nl/listo/src/types';
import DimensionContext from '@leasen_nl/listo/src/context/dimensionContext';
import { Container } from '@leasen_nl/listo/src/components/grid';
import { ColumnBox as Column } from '@leasen_nl/listo/src/components/column';
import { generateDimensions } from '@leasen_nl/listo/src/components/column/helpers';
import type { Theme } from '@types/index';
import { newsHighlight, newsItemGrid, newsOverview } from './atoms';

const Row = styled<any, Theme, _>('div')`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: stretch;
`;

const ButtonRow = styled<typeof Row, Theme, _>(Row)`
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

type OwnProps = {
  acf: ACFPage,
};

type Props = OwnProps;

const Newspage = ({
  acf: {
    rows,
  },
}: Props) => (
  <>
    <Rows rows={rows} />
    <Container>
      <Row>
        <DimensionContext.Provider value={generateDimensions(newsHighlight)}>
          <Column
            componentsOverCut={false}
            slidersEnabled={false}
            image={null}
          >
            <NewsPreviewHighlight />
          </Column>
        </DimensionContext.Provider>
        <DimensionContext.Provider value={generateDimensions(newsOverview)}>
          <Column
            componentsOverCut={false}
            slidersEnabled={false}
            image={null}
          >
            <NewsOverviewContainer />
          </Column>
        </DimensionContext.Provider>
      </Row>
      <Row>
        <DimensionContext.Provider value={generateDimensions(newsItemGrid)}>
          <NewsPreviewGrid />
        </DimensionContext.Provider>
      </Row>
      <Row>
        <ButtonRow>
          <LoadMoreButton />
        </ButtonRow>
      </Row>
    </Container>
  </>
);

export default Newspage;
